














import { Component, Prop, Vue } from "vue-property-decorator";

import { ResourceHelper } from "@/helper/resourceHelper";
import { CloudHelper } from "@/helper/cloudHelper";

import { CloudAccount } from "@/cloudAccount/cloudAccount";

@Component({
  components: {
  }
})
export default class CloudSingoutBalloon extends Vue {
    @Prop() private cloudAccount! : CloudAccount;

    signout(){
        CloudHelper.signOut(this.cloudAccount, 1);
        this.$emit("close");
    }

    manageAccount() {
        this.$emit("manageAccount");
        this.$emit("close");
    }

    deleteAccount(){
        this.$emit("isDeleteAccountModal");
        this.$emit("close");
    }

    close() {
        this.$emit("close");
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigButtonColor(){
        return {
            background: this.userConfigColor
        };
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
